module.exports = __webpack_public_path__ + "img/primary-master-card.22c49f6e.svg";